"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonTooltip = void 0;
const React = require("react");
const bronson_react_1 = require("@vwfs-bronson/bronson-react");
const tooltip_enum_1 = require("./tooltip.enum");
const BronsonTooltip = ({ children, alwaysVisible, className, content, placement, }) => {
    return (React.createElement(bronson_react_1.Tooltip, Object.assign({ content: content, placement: placement || tooltip_enum_1.Placement.TOP }, (alwaysVisible ? { alwaysVisible } : {}), (className ? { className } : {})), children));
};
exports.BronsonTooltip = BronsonTooltip;
